import axios from '../localAxios';
import { Workspace } from './types';
import { workspaceIdURL } from './workspacesURLs';

export async function getWorkspace(workspaceId: string) {
  const { data } = await axios.get<Workspace>(workspaceIdURL(workspaceId).href);
  return data;
}
